import _classCallCheck from "C:\\Sasria_digital\\VE_REL\\VendorEngage\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Sasria_digital\\VE_REL\\VendorEngage\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _assertThisInitialized from "C:\\Sasria_digital\\VE_REL\\VendorEngage\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import _get from "C:\\Sasria_digital\\VE_REL\\VendorEngage\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _inherits from "C:\\Sasria_digital\\VE_REL\\VendorEngage\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "C:\\Sasria_digital\\VE_REL\\VendorEngage\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Sasria_digital\\VE_REL\\VendorEngage\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as log from '../log';
import { isLayerSpec, isUnitSpec } from '../spec';
import { keys } from '../util';
import { assembleAxisSignals } from './axis/assemble';
import { parseLayerAxes } from './axis/parse';
import { parseData as _parseData } from './data/parse';
import { assembleLayoutSignals as _assembleLayoutSignals } from './layoutsize/assemble';
import { parseLayerLayoutSize } from './layoutsize/parse';
import { assembleLegends as _assembleLegends } from './legend/assemble';
import { Model } from './model';
import { assembleLayerSelectionMarks } from './selection/assemble';
import { UnitModel } from './unit';
export var LayerModel = /*#__PURE__*/function (_Model) {
  _inherits(LayerModel, _Model);

  var _super = _createSuper(LayerModel);

  function LayerModel(spec, parent, parentGivenName, parentGivenSize, config) {
    var _this;

    _classCallCheck(this, LayerModel);

    _this = _super.call(this, spec, 'layer', parent, parentGivenName, config, spec.resolve, spec.view);
    var layoutSize = Object.assign(Object.assign(Object.assign({}, parentGivenSize), spec.width ? {
      width: spec.width
    } : {}), spec.height ? {
      height: spec.height
    } : {});
    _this.children = spec.layer.map(function (layer, i) {
      if (isLayerSpec(layer)) {
        return new LayerModel(layer, _assertThisInitialized(_this), _this.getName('layer_' + i), layoutSize, config);
      } else if (isUnitSpec(layer)) {
        return new UnitModel(layer, _assertThisInitialized(_this), _this.getName('layer_' + i), layoutSize, config);
      }

      throw new Error(log.message.invalidSpec(layer));
    });
    return _this;
  }

  _createClass(LayerModel, [{
    key: "parseData",
    value: function parseData() {
      this.component.data = _parseData(this);

      var _iterator = _createForOfIteratorHelper(this.children),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var child = _step.value;
          child.parseData();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "parseLayoutSize",
    value: function parseLayoutSize() {
      parseLayerLayoutSize(this);
    }
  }, {
    key: "parseSelections",
    value: function parseSelections() {
      // Merge selections up the hierarchy so that they may be referenced
      // across unit specs. Persist their definitions within each child
      // to assemble signals which remain within output Vega unit groups.
      this.component.selection = {};

      var _iterator2 = _createForOfIteratorHelper(this.children),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var child = _step2.value;
          child.parseSelections();

          var _iterator3 = _createForOfIteratorHelper(keys(child.component.selection)),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var key = _step3.value;
              this.component.selection[key] = child.component.selection[key];
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "parseMarkGroup",
    value: function parseMarkGroup() {
      var _iterator4 = _createForOfIteratorHelper(this.children),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var child = _step4.value;
          child.parseMarkGroup();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "parseAxesAndHeaders",
    value: function parseAxesAndHeaders() {
      parseLayerAxes(this);
    }
  }, {
    key: "assembleSelectionTopLevelSignals",
    value: function assembleSelectionTopLevelSignals(signals) {
      return this.children.reduce(function (sg, child) {
        return child.assembleSelectionTopLevelSignals(sg);
      }, signals);
    } // TODO: Support same named selections across children.

  }, {
    key: "assembleSignals",
    value: function assembleSignals() {
      return this.children.reduce(function (signals, child) {
        return signals.concat(child.assembleSignals());
      }, assembleAxisSignals(this));
    }
  }, {
    key: "assembleLayoutSignals",
    value: function assembleLayoutSignals() {
      return this.children.reduce(function (signals, child) {
        return signals.concat(child.assembleLayoutSignals());
      }, _assembleLayoutSignals(this));
    }
  }, {
    key: "assembleSelectionData",
    value: function assembleSelectionData(data) {
      return this.children.reduce(function (db, child) {
        return child.assembleSelectionData(db);
      }, data);
    }
  }, {
    key: "assembleTitle",
    value: function assembleTitle() {
      var title = _get(_getPrototypeOf(LayerModel.prototype), "assembleTitle", this).call(this);

      if (title) {
        return title;
      } // If title does not provide layer, look into children


      var _iterator5 = _createForOfIteratorHelper(this.children),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var child = _step5.value;
          title = child.assembleTitle();

          if (title) {
            return title;
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return undefined;
    }
  }, {
    key: "assembleLayout",
    value: function assembleLayout() {
      return null;
    }
  }, {
    key: "assembleMarks",
    value: function assembleMarks() {
      return assembleLayerSelectionMarks(this, this.children.flatMap(function (child) {
        return child.assembleMarks();
      }));
    }
  }, {
    key: "assembleLegends",
    value: function assembleLegends() {
      return this.children.reduce(function (legends, child) {
        return legends.concat(child.assembleLegends());
      }, _assembleLegends(this));
    }
  }]);

  return LayerModel;
}(Model);